import {DrillDownResponse, DrillDownStatistics} from '../../../../../types/api/drillDown';
import {getKeyFromLevels} from './getKeyFromLevels';

/**
 * Merges global drill-down rows with region-specific statistics (counts).
 * Row structure from globalResponse, statistics from marketResponse keyed by level path.
 */
export function mergeGlobalRowsWithMarketStatistics(
  globalResponse: DrillDownResponse,
  marketResponse: DrillDownResponse | undefined
): DrillDownResponse {
  const marketByKey = new Map<string, DrillDownStatistics['statistics']>(
    marketResponse?.statisticsAggregated.map((row) => [
      getKeyFromLevels(row.levels),
      row.statistics,
    ]) ?? []
  );
  const statisticsAggregated = globalResponse.statisticsAggregated.map((row) => ({
    ...row,
    statistics: marketByKey.get(getKeyFromLevels(row.levels)) ?? [],
  }));
  return {
    translations: globalResponse.translations,
    statisticsAggregated,
  };
}
